module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-cover-3-26b62c3ae4abbea85c0b7d7018bfff34.webp";